export default __webpack_public_path__ + "52486e6d57e5578b813b3bf5394fcd59.png";